var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuSail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 714.883,
    height: 715.724,
    viewBox: "0 0 714.883 715.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_787",
    x: 0,
    y: 352.039,
    width: 69.309,
    height: 87.092,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_788",
    x: 0.504,
    y: 308.698,
    width: 65.874,
    height: 90.181,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_789",
    x: 7.269,
    y: 404.593,
    width: 77.628,
    height: 78.843,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_790",
    x: 17.682,
    y: 452.163,
    width: 85.723,
    height: 69.185,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_791",
    x: 37.072,
    y: 500.886,
    width: 92.677,
    height: 58.367,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_792",
    x: 63.619,
    y: 546.096,
    width: 97.891,
    height: 49.713,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_793",
    x: 96.641,
    y: 585.969,
    width: 101.283,
    height: 44.93,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_794",
    x: 135.383,
    y: 613.291,
    width: 102.8,
    height: 47.33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_795",
    x: 179.014,
    y: 633.688,
    width: 102.362,
    height: 50.631,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_796",
    x: 226.543,
    y: 646.979,
    width: 99.988,
    height: 54.484,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_797",
    x: 276.878,
    y: 652.342,
    width: 95.785,
    height: 59.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_798",
    x: 328.846,
    y: 649.393,
    width: 89.776,
    height: 66.331,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_799",
    x: 381.218,
    y: 638.322,
    width: 82.156,
    height: 74.482,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_800",
    x: 432.902,
    y: 620.401,
    width: 72.983,
    height: 82.746,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_801",
    x: 482.677,
    y: 596.269,
    width: 62.543,
    height: 90.249,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_802",
    x: 529.323,
    y: 566.471,
    width: 51.814,
    height: 96.137,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_803",
    x: 571.834,
    y: 531.709,
    width: 46.217,
    height: 100.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_804",
    x: 603.582,
    y: 492.799,
    width: 46.295,
    height: 102.456,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_805",
    x: 626.613,
    y: 450.605,
    width: 49.305,
    height: 102.767,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_806",
    x: 642.613,
    y: 406.07,
    width: 52.981,
    height: 101.114,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_807",
    x: 651.083,
    y: 360.193,
    width: 57.49,
    height: 97.567,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_808",
    x: 651.28,
    y: 314.019,
    width: 63.603,
    height: 92.238,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_809",
    x: 643.146,
    y: 268.709,
    width: 71.335,
    height: 85.197,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_810",
    x: 627.714,
    y: 225.233,
    width: 79.646,
    height: 76.59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_811",
    x: 605.848,
    y: 184.583,
    width: 87.584,
    height: 66.629,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_812",
    x: 578.107,
    y: 147.683,
    width: 94.126,
    height: 55.561,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_813",
    x: 545.146,
    y: 110.715,
    width: 98.881,
    height: 48.338,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_814",
    x: 507.707,
    y: 76.889,
    width: 101.81,
    height: 45.409,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_815",
    x: 466.625,
    y: 48.587,
    width: 102.874,
    height: 48.075,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-29"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-29"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_816",
    x: 422.859,
    y: 26.457,
    width: 101.957,
    height: 51.542,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-30"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-30"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_817",
    x: 377.36,
    y: 10.96,
    width: 99.138,
    height: 55.595,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-31"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-31"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_818",
    x: 331.166,
    y: 2.115,
    width: 94.477,
    height: 61.105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-32"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-32"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_819",
    x: 285.424,
    y: 0,
    width: 88.043,
    height: 68.243,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-33"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-33"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_820",
    x: 241.125,
    y: 4.573,
    width: 80.031,
    height: 76.532,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-34"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-34"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_821",
    x: 199.301,
    y: 15.905,
    width: 70.534,
    height: 84.685,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-35"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-35"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_822",
    x: 160.891,
    y: 34.332,
    width: 59.824,
    height: 91.861,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-36"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-36"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_823",
    x: 124.548,
    y: 59.962,
    width: 50.438,
    height: 97.31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-37"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-37"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_824",
    x: 88.821,
    y: 92.175,
    width: 44.826,
    height: 100.952,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-38"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-38"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_825",
    x: 58.355,
    y: 130.228,
    width: 46.952,
    height: 102.706,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-39"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-39"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_826",
    x: 33.829,
    y: 173.265,
    width: 50.173,
    height: 102.524,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-40"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-40"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_827",
    x: 15.828,
    y: 220.336,
    width: 53.912,
    height: 100.419,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-41"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-41"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_828",
    x: 5.234,
    y: 265.087,
    width: 58.848,
    height: 96.44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-42"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-42"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_829",
    x: 106.465,
    y: 335.059,
    width: 45.578,
    height: 45.607,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-43"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-43"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_830",
    x: 556.696,
    y: 335.059,
    width: 45.579,
    height: 45.607,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-44"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-44"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_413",
    x: 179.524,
    y: 343.948,
    width: 357.144,
    height: 85.385,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-45"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-45"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_831",
    x: 181.078,
    y: 134.517,
    width: 357.147,
    height: 193.644,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-46"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-46"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_832",
    x: 156.041,
    y: 407.115,
    width: 402.802,
    height: 174.091,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-47"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-47"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-1387.323 -386.715)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787-2",
    "data-name": "Path 787",
    d: "M1424.148,496.8c8.828.755,14.373,4.249,17.927,7.925a23.417,23.417,0,0,1,5.538,9.274,54.809,54.809,0,0,0-.424-8.08,60.76,60.76,0,0,0-4.56-17.556l-.068-.168-.006-.041v.014a35.591,35.591,0,0,0-7.352-9.537c-3.716-3.541-8.553-6.94-14.2-8.3-8.875-2.057-14.69-8.181-18.1-13.975a39.051,39.051,0,0,1-4.573-11.452,44.086,44.086,0,0,0-1.862,10.178,51.866,51.866,0,0,0,3.825,23.842,30.581,30.581,0,0,0,6.61,9.975A26.952,26.952,0,0,0,1424.148,496.8Z",
    transform: "translate(-1387.32 -86.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788-2",
    "data-name": "Path 788",
    d: "M1405.1,482.951a26.9,26.9,0,0,0,16.68,9.018c8.776,1.322,14.083,5.187,17.375,9.072a23.353,23.353,0,0,1,4.916,9.625,57.38,57.38,0,0,0,.115-8.087,61.446,61.446,0,0,0-3.4-17.826l-.067-.175v-.027h-.007a35.244,35.244,0,0,0-6.71-10c-3.461-3.777-8.047-7.487-13.6-9.186-8.721-2.657-14.123-9.146-17.152-15.162a39.083,39.083,0,0,1-3.811-11.722,43.574,43.574,0,0,0-2.529,10.023,52.062,52.062,0,0,0,2.24,24.058A30.808,30.808,0,0,0,1405.1,482.951Z",
    transform: "translate(-1386.89 -123.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789-2",
    "data-name": "Path 789",
    d: "M1412.965,494.924a26.92,26.92,0,0,0,18.259,5.193c8.821-.607,14.844,2.017,18.9,5.106a23.468,23.468,0,0,1,6.9,8.323,55.863,55.863,0,0,0-1.646-7.9,61.211,61.211,0,0,0-7.183-16.679l-.088-.155-.027-.027h.013a35.163,35.163,0,0,0-8.721-8.3c-4.2-2.947-9.483-5.571-15.27-6.036-9.092-.708-15.755-5.9-20.011-11.108a39.4,39.4,0,0,1-6.238-10.643,42.023,42.023,0,0,0-.29,10.339,51.484,51.484,0,0,0,7.344,23.026A30.731,30.731,0,0,0,1412.965,494.924Z",
    transform: "translate(-1381.13 -42.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_790)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790-2",
    "data-name": "Path 790",
    d: "M1439.122,501.565c8.64-1.922,14.993-.243,19.472,2.178a23.186,23.186,0,0,1,8.073,7.2,58.642,58.642,0,0,0-2.818-7.581,61.251,61.251,0,0,0-9.618-15.4l-.141-.121v-.027a35.32,35.32,0,0,0-9.868-6.886c-4.613-2.266-10.238-4.061-16.031-3.656-9.079.695-16.464-3.42-21.462-7.952a39.307,39.307,0,0,1-7.784-9.564,43.993,43.993,0,0,0,1.268,10.272A51.731,51.731,0,0,0,1411,491.67h-.013a30.9,30.9,0,0,0,9.314,7.547A27.009,27.009,0,0,0,1439.122,501.565Z",
    transform: "translate(-1372.26 -1.59)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791-2",
    "data-name": "Path 791",
    d: "M1428.892,502.746a27.01,27.01,0,0,0,18.966-.52c8.263-3.21,14.785-2.509,19.58-.782a23.118,23.118,0,0,1,9.059,5.9,54.944,54.944,0,0,0-3.926-7.075,60.954,60.954,0,0,0-11.843-13.766l-.141-.128-.028-.02a35.3,35.3,0,0,0-10.778-5.308c-4.9-1.538-10.731-2.475-16.4-1.194-8.884,2.057-16.794-.877-22.419-4.586a38.864,38.864,0,0,1-9.146-8.289,42.019,42.019,0,0,0,2.806,9.962,51.819,51.819,0,0,0,13.947,19.742h-.006A30.578,30.578,0,0,0,1428.892,502.746Z",
    transform: "translate(-1355.75 39.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792-2",
    "data-name": "Path 792",
    d: "M1456.563,501.6c7.669-4.411,14.224-4.7,19.229-3.71a23.432,23.432,0,0,1,9.854,4.472,55.742,55.742,0,0,0-4.951-6.4,61.4,61.4,0,0,0-13.779-11.85l-.155-.081-.027-.02a35.652,35.652,0,0,0-11.48-3.642c-5.064-.782-10.96-.83-16.383,1.288-8.458,3.372-16.719,1.652-22.845-1.153a38.9,38.9,0,0,1-10.272-6.819,41.822,41.822,0,0,0,4.262,9.422,51.728,51.728,0,0,0,16.734,17.421,30.284,30.284,0,0,0,11.129,4.418A26.974,26.974,0,0,0,1456.563,501.6Z",
    transform: "translate(-1333.14 78.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793-2",
    "data-name": "Path 793",
    d: "M1483.527,493.839a23.56,23.56,0,0,1,10.407,2.948,56.272,56.272,0,0,0-5.834-5.584,61.238,61.238,0,0,0-15.418-9.645l-.169-.074-.028-.007v.007a35.142,35.142,0,0,0-11.884-1.888c-5.133-.013-10.987.823-16,3.737-7.865,4.593-16.308,4.148-22.777,2.273a38.363,38.363,0,0,1-11.169-5.18,42.568,42.568,0,0,0,5.625,8.674,52.031,52.031,0,0,0,19.154,14.71v-.013a30.625,30.625,0,0,0,11.669,2.718,26.942,26.942,0,0,0,17.96-6.124C1471.987,494.864,1478.428,493.6,1483.527,493.839Z",
    transform: "translate(-1305.01 112.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794-2",
    "data-name": "Path 794",
    d: "M1490.471,494.741a23.322,23.322,0,0,1,10.724,1.335,56.987,56.987,0,0,0-6.616-4.64,61.039,61.039,0,0,0-16.68-7.2l-.182-.04-.026-.02a35.266,35.266,0,0,0-12.026-.047c-5.085.749-10.724,2.441-15.256,6.1-7.089,5.713-15.493,6.536-22.17,5.659a39.681,39.681,0,0,1-11.843-3.447,43.042,43.042,0,0,0,6.879,7.716,51.579,51.579,0,0,0,21.158,11.675,30.693,30.693,0,0,0,11.931.937A27.079,27.079,0,0,0,1473.2,504C1479.22,497.506,1485.4,495.273,1490.471,494.741Z",
    transform: "translate(-1272.01 135.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795-2",
    "data-name": "Path 795",
    d: "M1480.76,506.978c4.964-7.338,10.738-10.468,15.661-11.769a23.2,23.2,0,0,1,10.8-.3A54.265,54.265,0,0,0,1500,491.31a61.726,61.726,0,0,0-17.578-4.58l-.182-.007-.04-.013v.013a35.124,35.124,0,0,0-11.884,1.733c-4.9,1.524-10.232,4.061-14.157,8.343-6.159,6.724-14.333,8.8-21.078,8.95a38.76,38.76,0,0,1-12.215-1.632,41.992,41.992,0,0,0,7.958,6.6,51.785,51.785,0,0,0,22.7,8.357l-.014-.014a30.488,30.488,0,0,0,11.945-.883A26.948,26.948,0,0,0,1480.76,506.978Z",
    transform: "translate(-1234.85 153.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796-2",
    "data-name": "Path 796",
    d: "M1487.571,508.991c3.79-8.013,9.011-11.992,13.7-14.022a23.27,23.27,0,0,1,10.629-1.943,58.167,58.167,0,0,0-7.7-2.448,62,62,0,0,0-18.063-1.862l-.188.02h-.006a34.987,34.987,0,0,0-11.507,3.534c-4.62,2.239-9.5,5.578-12.733,10.393-5.046,7.588-12.823,10.879-19.472,12.039a39.2,39.2,0,0,1-12.316.25,43.814,43.814,0,0,0,8.862,5.322,52,52,0,0,0,23.7,4.809,30.562,30.562,0,0,0,11.661-2.7A26.9,26.9,0,0,0,1487.571,508.991Z",
    transform: "translate(-1194.37 164.34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797-2",
    "data-name": "Path 797",
    d: "M1504.921,494.522a23.13,23.13,0,0,1,10.238-3.514,56.236,56.236,0,0,0-8-1.261A61,61,0,0,0,1489,490.6l-.181.047h-.027a35.059,35.059,0,0,0-10.832,5.234c-4.242,2.921-8.546,6.947-11.007,12.2-3.853,8.262-11.028,12.707-17.416,14.859a39.631,39.631,0,0,1-12.16,2.131,44.037,44.037,0,0,0,9.577,3.9,52.182,52.182,0,0,0,24.146,1.167,30.5,30.5,0,0,0,11.115-4.445,26.812,26.812,0,0,0,11.25-15.263C1496.018,501.948,1500.591,497.227,1504.921,494.522Z",
    transform: "translate(-1151.5 168.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798-2",
    "data-name": "Path 798",
    d: "M1507.285,494.16a23.435,23.435,0,0,1,9.571-5,59.112,59.112,0,0,0-8.087-.054,61.239,61.239,0,0,0-17.792,3.568l-.189.067-.026.013a35.787,35.787,0,0,0-9.929,6.778c-3.757,3.521-7.419,8.141-9.091,13.712-2.557,8.741-9,14.191-14.98,17.3a39.065,39.065,0,0,1-11.681,3.912,43.9,43.9,0,0,0,10.036,2.421,51.775,51.775,0,0,0,24.031-2.462,30.606,30.606,0,0,0,10.339-6.03,27.051,27.051,0,0,0,8.849-16.781C1499.589,502.841,1503.407,497.492,1507.285,494.16Z",
    transform: "translate(-1107.23 166.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799-2",
    "data-name": "Path 799",
    d: "M1517,487.356a57.138,57.138,0,0,0-7.993,1.167,61.768,61.768,0,0,0-17.064,6.205l-.169.1-.026.013a35.9,35.9,0,0,0-8.775,8.2c-3.17,4.033-6.111,9.173-6.914,14.912-1.214,9.031-6.772,15.391-12.241,19.344a39.366,39.366,0,0,1-10.974,5.625,44.176,44.176,0,0,0,10.32.9,52.145,52.145,0,0,0,23.4-6.036,30.624,30.624,0,0,0,9.293-7.534,26.9,26.9,0,0,0,6.245-17.934c-.086-8.836,2.874-14.7,6.191-18.588A23.311,23.311,0,0,1,1517,487.356Z",
    transform: "translate(-1062.63 156.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800-2",
    "data-name": "Path 800",
    d: "M1515.49,484.7a55.82,55.82,0,0,0-7.723,2.381,61.324,61.324,0,0,0-15.91,8.734l-.156.108-.026.034h.013a35.07,35.07,0,0,0-7.446,9.442c-2.529,4.465-4.646,9.975-4.572,15.776.175,9.119-4.357,16.241-9.153,20.976a39.61,39.61,0,0,1-10.009,7.223,42.717,42.717,0,0,0,10.34-.681,51.873,51.873,0,0,0,22.209-9.517,29.967,29.967,0,0,0,8.06-8.849,26.893,26.893,0,0,0,3.439-18.649c-1.422-8.755.608-14.987,3.292-19.33A23.618,23.618,0,0,1,1515.49,484.7Z",
    transform: "translate(-1018.61 141.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801-2",
    "data-name": "Path 801",
    d: "M1490.745,495.669l-.141.148-.028.013h.014a35.475,35.475,0,0,0-5.929,10.461c-1.821,4.809-3.069,10.569-2.138,16.3,1.558,8.97-1.827,16.713-5.86,22.123a39.819,39.819,0,0,1-8.776,8.653,42.38,42.38,0,0,0,10.1-2.233,51.81,51.81,0,0,0,20.511-12.788,30.586,30.586,0,0,0,6.623-9.968,26.939,26.939,0,0,0,.58-18.959c-2.739-8.437-1.673-14.9.343-19.6a23.349,23.349,0,0,1,6.388-8.7,53.174,53.174,0,0,0-7.271,3.514A60.9,60.9,0,0,0,1490.745,495.669Z",
    transform: "translate(-976.21 121.15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802-2",
    "data-name": "Path 802",
    d: "M1502.955,486.274a23.074,23.074,0,0,1,5.018-9.571,52.5,52.5,0,0,0-6.664,4.573,61,61,0,0,0-12.606,13.071l-.108.168-.014.013v-.013a35.228,35.228,0,0,0-4.289,11.257c-1.066,5.025-1.45,10.906.35,16.443,2.886,8.633.7,16.787-2.461,22.743a38.952,38.952,0,0,1-7.379,9.881,42.151,42.151,0,0,0,9.659-3.73,51.959,51.959,0,0,0,18.352-15.722h-.014a30.914,30.914,0,0,0,5.059-10.852,26.961,26.961,0,0,0-2.305-18.831C1501.587,497.773,1501.667,491.211,1502.955,486.274Z",
    transform: "translate(-936.48 95.77)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803-2",
    "data-name": "Path 803",
    d: "M1498.643,481.781a23.175,23.175,0,0,1,3.527-10.232,56.432,56.432,0,0,0-5.914,5.531,61.516,61.516,0,0,0-10.5,14.825l-.067.169-.027.027v-.014a35.4,35.4,0,0,0-2.542,11.763c-.318,5.119.194,11.014,2.8,16.194,4.149,8.12,3.231,16.511.991,22.864a39.39,39.39,0,0,1-5.814,10.886,44.379,44.379,0,0,0,8.984-5.146,52.021,52.021,0,0,0,15.769-18.3,30.633,30.633,0,0,0,3.359-11.486,27,27,0,0,0-5.086-18.285C1499.006,493.361,1498.13,486.852,1498.643,481.781Z",
    transform: "translate(-900.27 66.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804-2",
    "data-name": "Path 804",
    d: "M1498.014,476.423a23.523,23.523,0,0,1,1.936-10.643,56.625,56.625,0,0,0-5,6.347,61.468,61.468,0,0,0-8.141,16.234l-.053.182-.014.027a35.323,35.323,0,0,0-.748,11.992c.458,5.119,1.841,10.859,5.214,15.6,5.308,7.385,5.651,15.823,4.383,22.453a39.482,39.482,0,0,1-4.094,11.621,43.229,43.229,0,0,0,8.1-6.434,51.5,51.5,0,0,0,12.843-20.443,30.689,30.689,0,0,0,1.612-11.877,26.9,26.9,0,0,0-7.79-17.293C1500.118,487.795,1498.264,481.508,1498.014,476.423Z",
    transform: "translate(-873.23 33.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805-2",
    "data-name": "Path 805",
    d: "M1519.837,502.575a26.966,26.966,0,0,0-10.3-15.931c-7.034-5.389-9.84-11.318-10.865-16.322a23.285,23.285,0,0,1,.316-10.8,55.961,55.961,0,0,0-3.979,7.021,60.559,60.559,0,0,0-5.585,17.273l-.04.175v.034a35.283,35.283,0,0,0,1.066,11.985c1.227,4.978,3.48,10.448,7.506,14.616,6.366,6.508,7.987,14.818,7.723,21.536a39.178,39.178,0,0,1-2.321,12.127,42.527,42.527,0,0,0,7.062-7.588,52.153,52.153,0,0,0,9.632-22.163h-.013A30.626,30.626,0,0,0,1519.837,502.575Z",
    transform: "translate(-853.62 -2.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806-2",
    "data-name": "Path 806",
    d: "M1511.928,478.112c-7.769-4.236-11.445-9.692-13.2-14.474a23.071,23.071,0,0,1-1.343-10.717,56.073,56.073,0,0,0-2.873,7.547A61.344,61.344,0,0,0,1491.6,478.4v.2a35.774,35.774,0,0,0,2.886,11.689c1.962,4.728,5.018,9.8,9.632,13.307,7.3,5.463,10.13,13.429,10.906,20.119a39.719,39.719,0,0,1-.446,12.322,44.225,44.225,0,0,0,5.821-8.559,52.015,52.015,0,0,0,6.166-23.37,30.887,30.887,0,0,0-2.031-11.81A26.937,26.937,0,0,0,1511.928,478.112Z",
    transform: "translate(-839.99 -40.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807-2",
    "data-name": "Path 807",
    d: "M1528.111,480.955a27.027,27.027,0,0,0-14.609-12.12c-8.33-3-12.781-7.837-15.243-12.316a23.512,23.512,0,0,1-2.941-10.4,56.718,56.718,0,0,0-1.7,7.9,61.264,61.264,0,0,0-.156,18.164l.027.182v.034a34.87,34.87,0,0,0,4.615,11.1c2.671,4.391,6.441,8.943,11.546,11.7,8.027,4.3,12.06,11.742,13.833,18.224a38.02,38.02,0,0,1,1.41,12.255,42.9,42.9,0,0,0,4.465-9.334,51.611,51.611,0,0,0,2.529-24.045A30.433,30.433,0,0,0,1528.111,480.955Z",
    transform: "translate(-832.77 -79.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808-2",
    "data-name": "Path 808",
    d: "M1536.448,479.491A30.324,30.324,0,0,0,1531,468.848a26.863,26.863,0,0,0-16.241-9.793c-8.681-1.76-13.805-5.861-16.9-9.921a23.118,23.118,0,0,1-4.437-9.861,57.381,57.381,0,0,0-.532,8.08,61.719,61.719,0,0,0,2.557,17.995l.04.175.028.04v-.02a35.441,35.441,0,0,0,6.219,10.319c3.291,3.932,7.709,7.864,13.173,9.834,8.591,3.049,13.677,9.78,16.428,15.917a38.662,38.662,0,0,1,3.238,11.9,42.125,42.125,0,0,0,3-9.9A51.737,51.737,0,0,0,1536.448,479.491Z",
    transform: "translate(-832.6 -119.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809-2",
    "data-name": "Path 809",
    d: "M1515.77,448.857c-8.855-.418-14.534-3.723-18.2-7.244a23.171,23.171,0,0,1-5.881-9.058,50.756,50.756,0,0,0,.715,8.04,61.291,61.291,0,0,0,5.2,17.388l.095.168.026.034h-.026a35.778,35.778,0,0,0,7.7,9.24c3.859,3.386,8.795,6.63,14.515,7.756,8.929,1.74,14.966,7.642,18.588,13.314a38.621,38.621,0,0,1,4.99,11.257,42.786,42.786,0,0,0,1.491-10.225,51.8,51.8,0,0,0-4.7-23.7v.013a30.144,30.144,0,0,0-6.974-9.726A26.859,26.859,0,0,0,1515.77,448.857Z",
    transform: "translate(-839.53 -157.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_810)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810-2",
    "data-name": "Path 810",
    d: "M1515.689,438.553c-8.815.944-14.94-1.45-19.115-4.377a23.205,23.205,0,0,1-7.184-8.066,55.352,55.352,0,0,0,1.917,7.844,61.972,61.972,0,0,0,7.81,16.389l.115.148.013.027a35.353,35.353,0,0,0,9,7.979c4.323,2.772,9.684,5.2,15.505,5.456,9.092.364,15.966,5.295,20.4,10.346a39.314,39.314,0,0,1,6.63,10.4,43.465,43.465,0,0,0-.082-10.333,51.5,51.5,0,0,0-8.222-22.736,30.664,30.664,0,0,0-8.363-8.566A27.023,27.023,0,0,0,1515.689,438.553Z",
    transform: "translate(-852.68 -194.88)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811-2",
    "data-name": "Path 811",
    d: "M1514.025,428.418c-8.552,2.266-14.967.823-19.539-1.45a23.554,23.554,0,0,1-8.337-6.886,56.38,56.38,0,0,0,3.1,7.48,61.787,61.787,0,0,0,10.2,15.013l.128.135.013.027a35.617,35.617,0,0,0,10.117,6.5c4.7,2.1,10.381,3.689,16.154,3.049,9.064-1.025,16.572,2.806,21.744,7.142a38.314,38.314,0,0,1,8.134,9.281,42.751,42.751,0,0,0-1.639-10.238,51.953,51.953,0,0,0-11.588-21.212v.02a30.277,30.277,0,0,0-9.578-7.2A26.988,26.988,0,0,0,1514.025,428.418Z",
    transform: "translate(-871.3 -229.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812-2",
    "data-name": "Path 812",
    d: "M1510.842,418.664c-8.114,3.514-14.67,3.055-19.533,1.5a23.076,23.076,0,0,1-9.273-5.551,59.066,59.066,0,0,0,4.188,6.927,60.913,60.913,0,0,0,12.343,13.307l.148.121.02.027a35.7,35.7,0,0,0,10.987,4.91c4.957,1.356,10.818,2.077,16.431.587,8.788-2.388,16.807.243,22.581,3.75a38.11,38.11,0,0,1,9.428,7.932,41.69,41.69,0,0,0-3.176-9.854,51.545,51.545,0,0,0-14.664-19.2,30.156,30.156,0,0,0-10.549-5.672A27.062,27.062,0,0,0,1510.842,418.664Z",
    transform: "translate(-894.93 -260.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813-2",
    "data-name": "Path 813",
    d: "M1506.238,413.454c-7.5,4.694-14.055,5.234-19.088,4.425a23.319,23.319,0,0,1-10-4.108,55.266,55.266,0,0,0,5.166,6.225,62.049,62.049,0,0,0,14.211,11.318l.162.088.041.013a34.969,34.969,0,0,0,11.573,3.2c5.1.607,11,.432,16.336-1.889,8.331-3.682,16.667-2.26,22.872.324a37.621,37.621,0,0,1,10.521,6.414,42.188,42.188,0,0,0-4.606-9.254,51.955,51.955,0,0,0-17.361-16.8,30.919,30.919,0,0,0-11.276-4A26.986,26.986,0,0,0,1506.238,413.454Z",
    transform: "translate(-923 -292.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814-2",
    "data-name": "Path 814",
    d: "M1482.085,418.132a23.37,23.37,0,0,1-10.488-2.556,56.652,56.652,0,0,0,6.037,5.362,61.706,61.706,0,0,0,15.742,9.051l.168.061.041.02h-.014a34.96,34.96,0,0,0,11.952,1.43c5.133-.169,10.947-1.214,15.87-4.31,7.7-4.89,16.126-4.741,22.661-3.116a38.746,38.746,0,0,1,11.353,4.748,41.831,41.831,0,0,0-5.929-8.437,51.87,51.87,0,0,0-19.695-14,30.388,30.388,0,0,0-11.763-2.273,26.959,26.959,0,0,0-17.718,6.772C1493.586,416.669,1487.2,418.172,1482.085,418.132Z",
    transform: "translate(-954.89 -321.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815-2",
    "data-name": "Path 815",
    d: "M1476.292,419.569a23.308,23.308,0,0,1-10.785-.938,53.235,53.235,0,0,0,6.793,4.4,61.877,61.877,0,0,0,16.915,6.562l.189.041.034.013a35.134,35.134,0,0,0,12.018-.391c5.058-.931,10.63-2.86,15.027-6.643,6.866-6,15.243-7.122,21.934-6.495a39.378,39.378,0,0,1,11.964,3,42.324,42.324,0,0,0-7.155-7.466,51.772,51.772,0,0,0-21.575-10.879,30.717,30.717,0,0,0-11.965-.479,27.071,27.071,0,0,0-16.5,9.375C1487.427,416.386,1481.324,418.848,1476.292,419.569Z",
    transform: "translate(-989.88 -345.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816-2",
    "data-name": "Path 816",
    d: "M1485,409.848c-4.674,7.527-10.313,10.879-15.2,12.363a23.334,23.334,0,0,1-10.778.708,57.9,57.9,0,0,0,7.365,3.318,62.207,62.207,0,0,0,17.719,3.919l.2.007h.027a34.812,34.812,0,0,0,11.831-2.2c4.849-1.707,10.062-4.431,13.846-8.856,5.875-6.967,13.975-9.335,20.705-9.719a38.89,38.89,0,0,1,12.269,1.16,42.094,42.094,0,0,0-8.194-6.32,51.911,51.911,0,0,0-22.985-7.48,30.642,30.642,0,0,0-11.9,1.335A26.964,26.964,0,0,0,1485,409.848Z",
    transform: "translate(-1027.16 -364.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817-2",
    "data-name": "Path 817",
    d: "M1476,411.507c-3.494,8.141-8.566,12.322-13.159,14.521a23.56,23.56,0,0,1-10.569,2.34,58.261,58.261,0,0,0,7.811,2.158,61.747,61.747,0,0,0,18.115,1.18l.182-.007h.027a35.6,35.6,0,0,0,11.344-3.979c4.547-2.414,9.3-5.915,12.343-10.865,4.769-7.763,12.41-11.344,18.992-12.754a39.056,39.056,0,0,1,12.323-.708,42.435,42.435,0,0,0-9.064-5,51.958,51.958,0,0,0-23.855-3.905,30.539,30.539,0,0,0-11.554,3.136A26.877,26.877,0,0,0,1476,411.507Z",
    transform: "translate(-1065.91 -377.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818-2",
    "data-name": "Path 818",
    d: "M1455.527,431.167a23.3,23.3,0,0,1-10.1,3.878,54.738,54.738,0,0,0,8.047.971,60.991,60.991,0,0,0,18.116-1.531l.182-.04.027-.014a35.366,35.366,0,0,0,10.643-5.632c4.108-3.062,8.269-7.251,10.563-12.6,3.521-8.4,10.527-13.1,16.82-15.485a38.917,38.917,0,0,1,12.079-2.57,43.6,43.6,0,0,0-9.718-3.561,51.968,51.968,0,0,0-24.16-.25,30.638,30.638,0,0,0-10.947,4.836,26.932,26.932,0,0,0-10.7,15.675C1464.153,423.424,1459.756,428.3,1455.527,431.167Z",
    transform: "translate(-1105.26 -384.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819-2",
    "data-name": "Path 819",
    d: "M1448.037,437.555a23.475,23.475,0,0,1-9.4,5.349,54.724,54.724,0,0,0,8.067-.236,62.071,62.071,0,0,0,17.664-4.222l.168-.088.027-.007a35.2,35.2,0,0,0,9.686-7.136c3.595-3.662,7.108-8.418,8.559-14.036,2.226-8.842,8.485-14.528,14.346-17.833A39.146,39.146,0,0,1,1508.684,395a42.816,42.816,0,0,0-10.13-2.057,51.858,51.858,0,0,0-23.91,3.338,30.579,30.579,0,0,0-10.117,6.414,26.967,26.967,0,0,0-8.221,17.084C1455.361,428.605,1451.766,434.089,1448.037,437.555Z",
    transform: "translate(-1144.22 -386.71)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_820)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820-2",
    "data-name": "Path 820",
    d: "M1432.073,451.925a56.467,56.467,0,0,0,7.945-1.471,62.017,62.017,0,0,0,16.821-6.846l.142-.094.027-.027a35.206,35.206,0,0,0,8.483-8.532c3-4.148,5.761-9.382,6.347-15.155.87-9.071,6.191-15.627,11.507-19.789A38.649,38.649,0,0,1,1494.1,394a42.565,42.565,0,0,0-10.339-.526,51.812,51.812,0,0,0-23.162,6.913v-.013a31.275,31.275,0,0,0-9.018,7.864,26.839,26.839,0,0,0-5.55,18.163c.4,8.842-2.327,14.811-5.49,18.8A23.314,23.314,0,0,1,1432.073,451.925Z",
    transform: "translate(-1181.95 -382.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821-2",
    "data-name": "Path 821",
    d: "M1425.872,461.758a54.262,54.262,0,0,0,7.642-2.657,61.634,61.634,0,0,0,15.58-9.321l.135-.115.027-.02a35.279,35.279,0,0,0,7.068-9.726c2.347-4.566,4.283-10.137,3.98-15.951-.513-9.1,3.757-16.39,8.37-21.293a38.714,38.714,0,0,1,9.732-7.588,43.188,43.188,0,0,0-10.3,1.046,52.064,52.064,0,0,0-21.859,10.353,30.745,30.745,0,0,0-7.716,9.139,26.906,26.906,0,0,0-2.731,18.784c1.754,8.68-.035,15.014-2.577,19.425A23.145,23.145,0,0,1,1425.872,461.758Z",
    transform: "translate(-1217.57 -373.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822-2",
    "data-name": "Path 822",
    d: "M1441.328,456.308l.121-.148.026-.007h-.013a35.615,35.615,0,0,0,5.531-10.69c1.633-4.87,2.7-10.67,1.518-16.363-1.875-8.917,1.207-16.767,5.032-22.325a39.357,39.357,0,0,1,8.458-8.97,43.225,43.225,0,0,0-10,2.6,51.882,51.882,0,0,0-20.018,13.543,30.534,30.534,0,0,0-6.259,10.2,27.048,27.048,0,0,0,.142,18.993c3.041,8.309,2.225,14.818.385,19.586a23.231,23.231,0,0,1-6.07,8.943,57.214,57.214,0,0,0,7.149-3.777A62.117,62.117,0,0,0,1441.328,456.308Z",
    transform: "translate(-1250.29 -357.47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823-2",
    "data-name": "Path 823",
    d: "M1421.657,471.176a23.578,23.578,0,0,1-4.661,9.739,54.826,54.826,0,0,0,6.482-4.816,61.644,61.644,0,0,0,12.12-13.543l.1-.155.013-.027a36.089,36.089,0,0,0,3.878-11.385c.877-5.072,1.039-10.974-.991-16.423-3.19-8.525-1.315-16.754,1.618-22.824a39.278,39.278,0,0,1,7.009-10.137,42.843,42.843,0,0,0-9.5,4.087,51.963,51.963,0,0,0-17.758,16.383,31.346,31.346,0,0,0-4.634,11.027,26.954,26.954,0,0,0,2.988,18.75C1422.6,459.622,1422.75,466.171,1421.657,471.176Z",
    transform: "translate(-1281.24 -335.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824-2",
    "data-name": "Path 824",
    d: "M1421.473,478.98a23.427,23.427,0,0,1-3.143,10.353,58.46,58.46,0,0,0,5.686-5.726,61.8,61.8,0,0,0,9.948-15.216l.068-.169.027-.02a35.232,35.232,0,0,0,2.1-11.844c.121-5.139-.608-11-3.414-16.086-4.451-7.945-3.817-16.369-1.827-22.824a39.684,39.684,0,0,1,5.4-11.068,43.423,43.423,0,0,0-8.782,5.47,51.533,51.533,0,0,0-15.074,18.865,30.38,30.38,0,0,0-2.934,11.607,26.906,26.906,0,0,0,5.754,18.069C1420.656,467.434,1421.8,473.895,1421.473,478.98Z",
    transform: "translate(-1311.67 -308.21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825-2",
    "data-name": "Path 825",
    d: "M1413.543,468.583c6.388,6.151,8.486,12.363,8.917,17.455a23.608,23.608,0,0,1-1.538,10.69,60.181,60.181,0,0,0,4.769-6.522,62.224,62.224,0,0,0,7.521-16.531l.053-.175.014-.034a35.805,35.805,0,0,0,.3-12.032c-.647-5.086-2.252-10.771-5.8-15.364-5.585-7.21-6.232-15.621-5.227-22.291a38.184,38.184,0,0,1,3.689-11.756,42.9,42.9,0,0,0-7.879,6.718,51.824,51.824,0,0,0-12.079,20.928,30.9,30.9,0,0,0-1.16,11.911A27.086,27.086,0,0,0,1413.543,468.583Z",
    transform: "translate(-1337.62 -275.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826-2",
    "data-name": "Path 826",
    d: "M1413.194,476.232c7.237,5.112,10.251,10.947,11.467,15.9a23.673,23.673,0,0,1,.086,10.8,55.5,55.5,0,0,0,3.717-7.149,61.65,61.65,0,0,0,4.944-17.489l.035-.175v-.034a36.04,36.04,0,0,0-1.526-11.932c-1.408-4.924-3.856-10.3-8.053-14.325-6.6-6.286-8.518-14.494-8.531-21.232A39.019,39.019,0,0,1,1417.2,418.4a42.555,42.555,0,0,0-6.758,7.831,51.853,51.853,0,0,0-8.794,22.507,30.626,30.626,0,0,0,.653,11.958A26.961,26.961,0,0,0,1413.194,476.232Z",
    transform: "translate(-1358.51 -239.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827-2",
    "data-name": "Path 827",
    d: "M1414.261,483.171c7.932,3.946,11.789,9.234,13.739,13.962a23.283,23.283,0,0,1,1.727,10.67,58.505,58.505,0,0,0,2.61-7.662,62.276,62.276,0,0,0,2.213-18.015v-.209a35.508,35.508,0,0,0-3.319-11.554c-2.152-4.661-5.388-9.611-10.144-12.95-7.473-5.193-10.6-13.037-11.648-19.687a40.073,40.073,0,0,1,0-12.343,44.274,44.274,0,0,0-5.5,8.761,51.853,51.853,0,0,0-5.253,23.6,30.64,30.64,0,0,0,2.448,11.729A27.02,27.02,0,0,0,1414.261,483.171Z",
    transform: "translate(-1373.84 -199.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828-2",
    "data-name": "Path 828",
    d: "M1402.026,476.85a27.113,27.113,0,0,0,15.068,11.56c8.43,2.7,13.057,7.365,15.674,11.736a23.115,23.115,0,0,1,3.325,10.313,64.965,64.965,0,0,0,.9-26.142l-.048-.189v-.02a35.352,35.352,0,0,0-5.025-10.933c-2.818-4.29-6.757-8.687-11.97-11.264-8.2-4-12.479-11.27-14.5-17.684a39.658,39.658,0,0,1-1.888-12.208,43.968,43.968,0,0,0-4.095,9.51,51.753,51.753,0,0,0-1.632,24.105A30.792,30.792,0,0,0,1402.026,476.85Z",
    transform: "translate(-1382.86 -160.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829-2",
    "data-name": "Path 829",
    d: "M1412.111,455.845a13.789,13.789,0,1,0,14.1-13.449A13.815,13.815,0,0,0,1412.111,455.845Z",
    transform: "translate(-1296.64 -101.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_830)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830-2",
    "data-name": "Path 830",
    d: "M1506.437,456.479A13.789,13.789,0,1,0,1492.314,470,13.8,13.8,0,0,0,1506.437,456.479Z",
    transform: "translate(-913.17 -101.33)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Rectangle_413)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413-2",
    "data-name": "Rectangle 413",
    width: 339.144,
    height: 67.385,
    transform: "translate(188.52 349.95)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831-2",
    "data-name": "Path 831",
    d: "M1525.291,520.917a14.566,14.566,0,0,0-25.858,0h-8.876A67.389,67.389,0,0,0,1423.17,588.3h339.147a67.393,67.393,0,0,0-67.385-67.386h-8.884a14.561,14.561,0,0,0-25.852,0H1602.49l-.749-15.924a46.7,46.7,0,1,0-17.994,0L1583,520.917Zm67.318,0,.135-12.471.134,12.471Zm-32.637-79.128a48.362,48.362,0,0,0-3.089,6.805,35.524,35.524,0,0,0-1.443,5.611,32.127,32.127,0,0,0-.513,3.736l-.149,1.329s0-.465-.006-1.336a26.015,26.015,0,0,1,.114-3.784,36.449,36.449,0,0,1,.985-5.861,37.807,37.807,0,0,1,2.691-7.257,39.423,39.423,0,0,1,5.119-7.649,35.2,35.2,0,0,1,7.7-6.886,41.093,41.093,0,0,1,10.022-4.768,43.485,43.485,0,0,1,11.345-1.767,42.852,42.852,0,0,1,11.344,1.767,40.836,40.836,0,0,1,10.022,4.762,35.59,35.59,0,0,1,7.7,6.886,39.614,39.614,0,0,1,5.112,7.655,37.865,37.865,0,0,1,2.7,7.257,36.321,36.321,0,0,1,.971,5.848,25.55,25.55,0,0,1,.122,3.8l-.014,1.336-.141-1.336a34.189,34.189,0,0,0-.512-3.723,36.393,36.393,0,0,0-1.444-5.618,48.581,48.581,0,0,0-3.1-6.805,37.989,37.989,0,0,0-5.248-7.028,40.627,40.627,0,0,0-7.506-6.2,38.2,38.2,0,0,0-9.436-4.289,38.787,38.787,0,0,0-21.157,0,38.307,38.307,0,0,0-9.436,4.289,40.115,40.115,0,0,0-7.5,6.2A37.5,37.5,0,0,0,1559.972,441.789Zm3.547,17.482a29.225,29.225,0,1,1,37.386,27.983l-.142-3.029a8.3,8.3,0,0,0-6.643-7.932,8.009,8.009,0,0,0-9.381,7.507l-.163,3.453A29.2,29.2,0,0,1,1563.519,459.271Z",
    transform: "translate(-1233.09 -272.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1387.32, 386.71)",
    filter: "url(#Path_832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832-2",
    "data-name": "Path 832",
    d: "M1440.157,521.123,1443.118,506a66.774,66.774,0,0,0,23.526,37.527c28.557,24.773,73.362,31.5,96.367,33.332a44.452,44.452,0,0,1,26.7,11.8l22.075,20.5,22.074-20.5a44.452,44.452,0,0,1,26.7-11.8c22.264-1.767,64.856-8.215,93.467-31.059A66.829,66.829,0,0,0,1780.6,506l2.961,15.122s20.7-35.241,20.7-68.047c0,0-28,25.515-52.352,34.02l14.13,3.278H1457.68l14.13-3.278c-24.348-8.5-52.352-34.02-52.352-34.02C1419.458,485.882,1440.157,521.123,1440.157,521.123Zm104.71,35.146c53.4,2.469,63.17,22.015,63.17,22.015l3.562-79.823,4.079,79.877s9.767-19.546,63.17-22.022,70.226-29.669,70.226-29.669-13.355,28.193-72.816,36.239c-50.955,6.9-61.834,26.432-63.911,31.888l-.344.972c-.081.3-.135.506-.135.506v-.108l-.019.054-.574-1.625v-.094c-2.3-5.76-13.57-24.84-63.818-31.646C1488,554.785,1474.65,526.6,1474.65,526.6S1491.464,553.794,1544.867,556.269Z",
    transform: "translate(-1254.42 -39.96)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSail);
export default __webpack_public_path__ + "static/media/menuSail.65de287d31a9f3532c9b8d8bf5a4e5af.svg";
export { ForwardRef as ReactComponent };